import AccountConfirmation from '../components/AccountConfirmation'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { updateSignUpSettings } from '../../../routes/signup/modules/signup'

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => bindActionCreators({
  updateSignUpSettings
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountConfirmation)



// WEBPACK FOOTER //
// ./src/routes/accountConfirmation/containers/AccountConfirmationContainer.js